module.exports = __webpack_public_path__ + "img/s.4efe9ff3.jpg";